import Vue from 'vue';
import * as Sentry from '@sentry/browser';

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    dsn: 'https://8257ee176d3b465991fedb133346f195@sentry.io/1424871',
    integrations: [new Sentry.Integrations.Vue({
      Vue,
      attachProps: true,
    })],
  });
}
